import 'devextreme/dist/css/dx.light.css';
import './assets/theme.css';
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { initAuthSessionListener, initSessionWatchdog } from './utils/authSession.js'
import moment from 'moment'

import {Amplify} from 'aws-amplify'
import awsConfig from './aws-exports'
import "@aws-amplify/ui-vue/styles.css"

// Configurar traducciones para Amplify UI
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-vue';

I18n.putVocabularies(translations);
I18n.setLanguage('es');

I18n.putVocabularies({
  es: {
    'Sign In': 'Iniciar Sesión',
    'Sign in': 'Iniciar Sesión',
    'Sign Up': 'Registrarse',
    'Create Account': 'Crear Cuenta',
    'Create a new account': 'Crear una nueva cuenta',
    'Sign in to your account': 'Inicia sesión en tu cuenta',
    'Username': 'Usuario',
    'Enter your Username': 'Ingrese su usuario',
    'Email': 'Correo Electrónico',
    'Enter your Email': 'Ingrese su correo electrónico',
    'Password': 'Contraseña',
    'Enter your Password': 'Ingrese su contraseña',
    'Forgot your password?': '¿Olvidaste tu contraseña?',
    'Reset Password': 'Restablecer Contraseña',
    'Reset your password': 'Restablece tu contraseña',
    'Back to Sign In': 'Volver a Iniciar Sesión',
    'Send code': 'Enviar código',
    'Code': 'Código',
    'Confirmation Code': 'Código de Confirmación',
    'Enter your Confirmation Code': 'Ingrese su código de confirmación',
    'Lost your code?': '¿Perdiste tu código?',
    'Resend Code': 'Reenviar Código',
    'New Password': 'Nueva Contraseña',
    'Confirm Password': 'Confirmar Contraseña',
    'Please confirm your Password': 'Por favor confirma tu contraseña',
    'Name': 'Nombre',
    'Enter your Name': 'Ingrese su nombre',
    'Preferred Username': 'Nombre de Usuario Preferido',
    'Enter your Preferred Username': 'Ingrese su nombre de usuario',
    'Phone Number': 'Número de Teléfono',
    'Enter your Phone Number': 'Ingrese su número de teléfono',
    'Submit': 'Enviar',
    'Submitting': 'Enviando...',
    'Signing in': 'Iniciando sesión...',
    'Skip': 'Omitir',
    'Verify': 'Verificar',
    'Verify Contact': 'Verificar Contacto',
    'Confirm': 'Confirmar',
    'Incorrect username or password.': 'Usuario o contraseña incorrectos.',
    'User does not exist.': 'El usuario no existe.',
    'User already exists': 'El usuario ya existe',
    'Invalid password format': 'Formato de contraseña inválido',
    'Account recovery requires verified contact information': 'La recuperación de cuenta requiere información de contacto verificada',
    'Invalid phone number format': 'Formato de número de teléfono inválido',
    'An account with the given email already exists.': 'Ya existe una cuenta con este correo electrónico.',
    'Username cannot be empty': 'El nombre de usuario no puede estar vacío',
    'Password did not conform with policy: Password not long enough': 'La contraseña no cumple con la política: La contraseña no es lo suficientemente larga'
  }
});

import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license.ts'; 
 
config({ licenseKey});  


// Configurar moment.js en español globalmente
moment.updateLocale('es', {
    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
    monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
    weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
    weekdaysShort: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
    weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
    week: {
        dow: 0 // Domingo es el primer día de la semana (0)
    }
})

Amplify.configure(awsConfig);
initAuthSessionListener();

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(pinia)
app.use(router)

app.mount('#app')

initSessionWatchdog()